// extracted by mini-css-extract-plugin
export var darkMode = "_x-0";